import API from '../../../../api/baseUrl';
import { getTokens } from '../../../../auth/AuthState';
import { useState } from 'react';
import { getClinicianProfileBasic } from '../../../../store/ai2';
import { useDispatch, useSelector } from 'react-redux';

export const useUpdateTeams = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { selectedTenancy } = useSelector((state) => state.clinicianProfile);

  const postUpdateTeams = async (postUpdateTeamsPayload) => {
    setIsLoading(true);
    try {
      const { id: authorization_token } = await getTokens();

      let options = {
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + authorization_token,
        },
      };
      const payload = {
        teams: postUpdateTeamsPayload.teams,
        tenancyId: selectedTenancy.tenancy_id,
      };
      const result = await API.post(`updateTeams `, { ...payload }, options);
      const getTaskData = await getClinicianProfileBasic();
      await dispatch(getTaskData);
      return result;
    } catch (error) {
      console.error(
        'An error occurred during manage clinicians between team',
        error,
      );
      setErrorMessage(
        error?.response?.data?.message ||
          'Unknown error in manage clinicians between team',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postUpdateTeams,
    errorMessage,
    isLoading,
  };
};
